import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router} from '@angular/router';

import {AuthService} from '../services/auth.service';
import {unauthenticatedEntryRoute} from '../config/agaia-web-access.config';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService.userHasLoggedIn) {
            return this.router.navigate([unauthenticatedEntryRoute()]);
        }

        return true;
    }
}
